import Glide from "@glidejs/glide";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["slider"];

  connect() {
    this.createGlide();
    window.addEventListener("resize", this.resizeHandler.bind(this));
  }

  resizeHandler() {
    this.glide.destroy();
    this.createGlide();
  }

  createGlide() {
    const sliders = this.sliderTarget.querySelectorAll(".glide__slide");
    if (sliders.length === 0) {
      return;
    }

    if (window.innerWidth >= 700) {
      this.glide = new Glide(this.sliderTarget, {
        type: sliders.length <= 2 ? "slide" : "carousel",
        startAt: 0,
        perView: 2,
        peek: { before: 0, after: 133 },
        gap: 24,
        swipeThreshold: 5,
        dragThreshold: 5,
        animationDuration: 5
      }).mount();
    } else {
      this.glide = new Glide(this.sliderTarget, {
        type: sliders.length <= 2 ? "slide" : "carousel",
        startAt: 0,
        perView: 1,
        peek: { before: 0, after: 51 },
        gap: 24,
        swipeThreshold: 5,
        dragThreshold: 5,
        animationDuration: 5
      }).mount();
    }
    this.updateDots();

    this.glide.on("run.after", () => {
      this.updateDots();
    })
  }

  updateDots() {
    const bullets = this.sliderTarget.querySelectorAll('.glide__bullet');
    const activeIndex = Array.from(bullets).findIndex(bullet => bullet.classList.contains('glide__bullet--active'));

    if (activeIndex === 0 || activeIndex === bullets.length - 1) {
      bullets.forEach(bullet => {
        bullet.classList.remove('glide__bullet--left', 'glide__bullet--right');
      });
    
      if (activeIndex === 0) {
        bullets[bullets.length - 1].classList.add('glide__bullet--right');
      } else if (activeIndex === bullets.length - 1) {
        bullets[0].classList.add('glide__bullet--left');
      }
    }
  
    
  }

  handleClickNextSlide(event) {
    event.preventDefault();
    this.glide.go("<");
  }

  handleClickPrevSlide(event) {
    event.preventDefault();
    this.glide.go(">");
  }

  disconnect() {
    this.glide.destroy();
    window.removeEventListener("resize", this.resizeHandler);
  }
}
